import { Component } from '@angular/core';

@Component({
  selector: 'lib-survey-not-found',
  imports: [],
  templateUrl: './survey-not-found.html',
  styleUrl: './survey-not-found.css',
})
export class SurveyNotFound {
  // For external links, we use the standard window object
  goHome() {
    window.location.href = 'https://infersurveys.com';
  }

  contactSupport() {
    window.location.href = 'https://infersurveys.com/contact/';
  }
}
